
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M238.07 450.79v165.42C156.55 638.65 76.75 643.37 0 643.37V450.79zM0 816.52c64.19 0 147.45-2.72 238.07-22.24v178.14H0zM1000 428.3v544.16H761.93V502.79c19.85-11.54 39.66-22 59.53-31.22 39.26-18.23 78.75-31.5 119-38.24a358.15 358.15 0 0159.54-5.03zM1000 139.72v115.43c-79 0-157.29 17.44-238.07 53.15V139.72zM619.05 27.54v360.39c-53.93 35.48-106.66 75.33-157 114.55A677.4 677.4 0 01381 556.92V27.54zM568.46 639.07q25.53-19.91 50.59-38.88v372.27H381V749.63c66-27.63 128-64.25 187.46-110.56z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M1000 309.83v63.79a415.82 415.82 0 00-59.51 4.3c-40.7 5.87-80.18 17.55-119 33.77-20 8.33-39.79 17.85-59.53 28.4-47.72 25.5-95 57-142.88 92-27.77 20.27-55.77 41.74-84.2 63.88C483.38 636 431.91 666.61 381 689.86a745 745 0 01-142.91 48.39c-83.66 19.32-164 23.59-238.09 23.59v-63.79c76.75 0 156.42-4.49 238.07-25.06A666.24 666.24 0 00381 619.22a725.29 725.29 0 00114.64-73.62c39.92-31.09 81.33-62.55 123.41-91.68 40.74-28.21 82.11-54.24 123.41-75.65 6.51-3.37 13-6.64 19.47-9.75q30-14.52 59.53-25.39c60.54-22.35 119.45-33.3 178.54-33.3z"}})])
          )
        }
      }
    